import { bov3_api } from '../..';
import { PropertyType } from '../../../common';

export const handleTransaction = (token: string, data: PropertyType, action: string): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: token,
			action: action,
			request: 'HandleTransaction',
			trx_id: data?.transaction_id as number,
		})
		.then((res) => {
			return res;
		});
